<div class="content-container">
  <h2>Scan QR Code</h2>
  <p>You will need an authenticator app to complete this process.</p>

  <div class="qr-code-box">
    <p class="phone-number"
      >Scan the QR code with your authentication app to generate a unique
      code</p
    >
    <qrcode
      [qrdata]="otpAuthUrl"
      [allowEmptyString]="true"
      [width]="256"
      [errorCorrectionLevel]="'M'"
    />
  </div>

  <form [formGroup]="otpForm">
    <div class="input-container">
      <label for="otp" class="label"
        >Enter code from your authentication app</label
      >
      <lib-input
        formControlName="totpCode"
        [placeholder]="'Enter verification code'"
        [isInvalid]="isInvalid('totpCode')"
        [formControls]="f['totpCode'] || null"
        [errorMessage]="errorMessages.totpCode"
      />
    </div>

    <div *ngIf="errorMessage" class="error-message">
      <i class="fas fa-exclamation-triangle"></i> {{ errorMessage }}
    </div>

    <div class="btn-container">
      <g99-button
        width="100%"
        variant="medium"
        color="green"
        [disabled]="!otpForm.valid"
        [loadingText]="'Verifying...'"
        [isLoading]="isLoading"
        (buttonClick)="onVerify()"
      >
        Verify
      </g99-button>
    </div>

    <div class="additional-options">
      <p>Still facing issue?</p>
      <a
        href="javascript:void(0)"
        class="option-link"
        (click)="logoutAndLogin()"
      >
        Try login again
      </a>
    </div>
    <div class="additional-options">
      <p>Want to choose a different authentication method?</p>
      <a
        href="javascript:void(0)"
        class="option-link"
        (click)="navigateToAuthSelectionPage()"
      >
        Select authentication method
      </a>
      <p class="support-text">
        If you need assistance with this process, please reach out to our
        <a class="option-link" href="mailto:support@growth99.com"
          >support team</a
        >.
      </p>
    </div>
  </form>
</div>
